import { Box, Divider, FormControlLabelProps, ListItemIcon, ListItemText, MenuItem, MenuList, RadioProps } from '@mui/material'
import Label from '../../rhf-mui/ui/Label'
import DialogBase, { DialogBaseProps } from './DialogBase'
import { DialogOptions } from './DialogOptions'
import { DialogEventArgs } from './DialogEventArgs';

export type MenuDialogBaseProps = DialogBaseProps & {
  options?: DialogOptions;

  displayMember?: string;
  valueMember?: string;
  iconMember?: string;

  markProps?: RadioProps;// RadioProps - 統一的 Radio 屬性樣式
  formControlLabelProps?: FormControlLabelProps
}


const MenuDialogBase = ({
  options,

  displayMember = "label", valueMember = "value", iconMember,

  markProps, formControlLabelProps,

  ...props }: MenuDialogBaseProps) => {

  function onMenuItemClick(val: string) {
    let e = new DialogEventArgs(undefined, 'Yes', val);
    props.onDialogResult?.(e);
  }

  return (
    <DialogBase style={{ paddingTop: '0px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px' }}
      content={
        <Box sx={{ maxHeight: '400px' }}>
          <MenuList>
            {render_MenuItems()}
          </MenuList>
        </Box>
      }

      {...props}
    />
  )

  function render_MenuItems() {
    return (options == null ? <></> : options.map((option: any, index: number) => {

      if (typeof (option) === "string") {
        option = { value: option, label: option }
      }

      const val = String(option[valueMember as string]);
      const lbl = option[displayMember as string];

      const key = `${val}`;

      const icon = (iconMember == null ? undefined : option[iconMember as string]);

      // https://caniuse.com/?search=replaceAll
      // iOS 13.3 以下不支援 replaceAll
      //'------------' 超過10個 視為分隔號
      if (typeof (lbl) === "string" && lbl.length >= 10 && lbl.replace(/\-/g, '').length === 0) {
        return <Divider key={'__divider' + index + "__"} />;
      }
      return (
        <MenuItem key={key} sx={{ py: 1.5 }} onClick={() => { onMenuItemClick(val) }} >
          {iconMember == null ? undefined :
            <ListItemIcon>
              {icon}
            </ListItemIcon>
          }

          {
            (typeof (lbl) === "string" ?
              <ListItemText><Label text={lbl} /></ListItemText>
              :
              lbl)
          }
        </MenuItem>
      )
    })
    )
  }



}

export default MenuDialogBase